<template>
  <FullLayout />
</template>

<script setup lang="ts">
import FullLayout from './layouts/FullLayout.vue';
</script>
